module.exports = __webpack_public_path__ + "role.879eba0eb5be0a7e68e07840cf2cca26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/role.svg
// module id = 1146
// module chunks = 0